import {
  Spacing,
  MediaQueries,
  Typography
} from 'UI'

export default theme => ({
  root: {
    width: '100%',
    position: 'relative',
    maxWidth: 470
  },
  inputGroup: {
    width: '100%',
    position: 'relative'
  },
  input: {
    width: '100%',
    height: 54,
    borderRadius: 8,
    border: 'solid 1px',
    borderColor: theme.neutral[0],
    borderWidth: 1,
    padding: '0 42px 0 16px',
    outline: 'none',
    color: theme.primary[400],
    transition: 'transform .25s linear,opacity .25s linear, border-color .25s linear',
    background: theme.neutral[400],
    font: {
      family: Typography.fontFamily,
      size: Typography.body2.fontSize
    },
    '&::placeholder': {
      fontFamily: Typography.secondaryFontFamily,
      fontSize: 14,
      color: theme.neutral[200]
    },
    '&:hover': {
      borderColor: theme.primary[1300]
    }
  },
  controlIcon: {
    fontSize: 16
  },
  results: {
    top: 62,
    width: 491,
    borderRadius: 8,
    backgroundColor: theme.neutral[400],
    border: `1px solid ${theme.neutral[0]}`,
    position: 'absolute',
    padding: () => Spacing(4),
    transition: 'all .2s linear',
    minWidth: 380
  },
  searchItem: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  textClass: {
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    width: '100%',
    '&:hover': {
      color: theme.primary[0]
    }
  },
  icon: {
    padding: () => Spacing(0, 3, 0, 0),
    height: 14,
    fontHeight: '14px',
    color: theme.secondary[0],
    fontSize: 14
  },
  [`${MediaQueries.tablet}`]: {
    root: {
      maxWidth: 'unset'
    },
    results: {
      top: ({ topBarOpen, bannerOpen }) => bannerOpen ? 155 : topBarOpen ? 143 : 76,
      left: 0,
      position: 'fixed',
      width: 'calc(100% - 30px)',
      margin: '0 15px'
    }
  },
  [`${MediaQueries.mobile}`]: {
    root: {
      maxWidth: 'unset'
    },
    results: {
      top: ({ topBarOpen, bannerOpen }) => bannerOpen ? 155 : topBarOpen ? 143 : 76,
      left: 0,
      position: 'fixed',
      width: 'calc(100% - 30px)',
      margin: '0 15px'
    }
  }
})
